import type { MoveToCommand } from '@/lib/elements/types/move-to-command'
import type { LineToCommand } from '@/lib/elements/types/line-to-command'
import type { CurveToCommand } from '@/lib/elements/types/curve-to-command'

export function clampFinite(value: number): number {
  return Number.isFinite(value) ? value : 0
}

export function point(x: number, y: number): { x: number; y: number } {
  return { x: clampFinite(x), y: clampFinite(y) }
}

export function moveTo(x: number, y: number): MoveToCommand {
  return { moveTo: point(x, y) }
}

export function lineTo(x: number, y: number): LineToCommand {
  return { lineTo: point(x, y) }
}

export function curveToCubic(
  cx1: number,
  cy1: number,
  cx2: number,
  cy2: number,
  x: number,
  y: number
): CurveToCommand {
  return {
    curveTo: {
      controlX: clampFinite(cx1),
      controlY: clampFinite(cy1),
      controlX2: clampFinite(cx2),
      controlY2: clampFinite(cy2),
      x: clampFinite(x),
      y: clampFinite(y),
    },
  }
}
